import { useTranslation } from "react-i18next";
import Certifications from "./Certification";
import Contacts from "./Contacts";
import Formations from "./Formations";
import Nav from "./Nav";
import Realisations from "./Realisations";
import Skills from "./Skills";
import Xp from "./Xp";

export default function PortFolio() {
	const { t } = useTranslation();

	return (
		<div className="text-white bg-[#212529] font-inter font-light">
			<div
				id="home"
				className="h-screen bg-[url('../public/imgs/bg.jpeg')] bg-cover flex items-center"
			>
				<h1 className="text-4xl text-center font-bold flex-1">
					Thibaut Herbet <br />
					{t("webdev")}
				</h1>
			</div>
			<div className="flex flex-col space-y-20">
				<Nav />
				{/* 
                    <About />
					*/}
				<Xp />
				<Formations />
				<Realisations />
				<Certifications />
				<Skills />
				<Contacts />
			</div>
		</div>
	);
}
